import React from 'react'
import PlaceOrdersDetails from './PlaceOrdersDetails'

const PlaceOrdersBody = ({orderType}) => {
    return (
        <div className="view-qualities folded router-view-container">
          <PlaceOrdersDetails orderType={orderType}/>
      </div>
    )
}

export default PlaceOrdersBody


